export function removeUrlParams(url, params) {
  const parsed = new URL(url)

  if (!params) {
    parsed.search = ''
    return parsed.toString()
  }

  const list = Array.isArray(params) ? params : [params]

  list.forEach((param) => {
    if (param) {
      parsed.searchParams.delete(param)
    }
  })

  return parsed.toString()
}
